(() => {
  const hydrateSlide = (slide) => {
    if (!slide) return;

    slide.querySelectorAll('source[data-deferred-srcset]').forEach((source) => {
      source.srcset = source.dataset.deferredSrcset;
      source.removeAttribute('data-deferred-srcset');
    });

    slide.querySelectorAll('img[data-deferred-src]').forEach((image) => {
      if (image.dataset.deferredSrcset) {
        image.srcset = image.dataset.deferredSrcset;
        image.removeAttribute('data-deferred-srcset');
      }

      image.fetchPriority = 'high';
      image.src = image.dataset.deferredSrc;
      image.removeAttribute('data-deferred-src');
    });
  };

  const hydrateAllSlides = (component) => {
    component.querySelectorAll('.swiper-slide').forEach(hydrateSlide);
  };

  const setup = (component) => {
    if (component.dataset.deferredImagesReady === 'true') return;

    const swiper = component.sliderInstance?.slider;
    if (!swiper) {
      requestAnimationFrame(() => setup(component));
      return;
    }

    component.dataset.deferredImagesReady = 'true';
    hydrateSlide(swiper.slides[swiper.activeIndex]);

    swiper.on('activeIndexChange', () => {
      hydrateSlide(swiper.slides[swiper.activeIndex]);
    });

    component.addEventListener('pointerdown', () => hydrateAllSlides(component), { once: true, passive: true });
    component.addEventListener('keydown', () => hydrateAllSlides(component), { once: true });
  };

  customElements.whenDefined('slideshow-component').then(() => {
    document.querySelectorAll('slideshow-component[data-defer-slide-images]').forEach(setup);
  });
})();
